import { render, staticRenderFns } from "./RightGroups.vue?vue&type=template&id=666c68cc&scoped=true&"
import script from "./RightGroups.vue?vue&type=script&lang=js&"
export * from "./RightGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666c68cc",
  null
  
)

export default component.exports